export default "__VITE_ASSET__fc598836__"